export interface GetSessionResponse {
    username: string;
    email: string;
    fullname: string;
    languages: {
        [code: string]: string;
    };
}
